import { getGuid } from "owa-guid";

const windowCorrelationIds = new WeakMap<Window, string>();
const windowFlowKeyCorrelationIds = new WeakMap<Window, Map<string, string>>();

/**
 * Returns a stable per-window correlation ID for flyout debug logging.
 * Uses a WeakMap keyed by window to avoid polluting the global object.
 * The ID is lazily generated and cached per window.
 */
export function getFlyoutDebugCorrelationId(): string {
    let id = windowCorrelationIds.get(window);
    if (!id) {
        id = getGuid();
        windowCorrelationIds.set(window, id);
    }
    return id;
}

/**
 * Returns a stable correlation ID scoped to a specific window + flow key
 * (e.g. `mode:hostItemIndex` for per-compose-tab tracking).
 * Uses a WeakMap keyed by window to avoid polluting the global object.
 * The ID is lazily generated and cached per window + flow key.
 */
export function getFlyoutDebugCorrelationIdByFlowKey(targetWindow: Window, flowKey: string): string {
    let flowMap = windowFlowKeyCorrelationIds.get(targetWindow);
    if (!flowMap) {
        flowMap = new Map<string, string>();
        windowFlowKeyCorrelationIds.set(targetWindow, flowMap);
    }
    
    let id = flowMap.get(flowKey);
    if (!id) {
        id = getGuid();
        flowMap.set(flowKey, id);
    }
    return id;
}
